import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ApiHttpClient } from 'app/http/clients/api';
import { PaginatedThread } from 'app/messages/message-service/message.model';
import { Call } from 'app/models/dto/call.model';
import { PaginationService } from 'ngx-pagination';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface PaginationLink {
  url: string;
  label: string;
  active: boolean;
}

export interface PaginatedCallHistory {
  current_page: number;
  data: Call[];
  first_page_url: string;
  from: number;
  to: number;
  last_page: number;
  last_page_url: string;
  next_page_url: string;
  links: PaginationLink[];
  path: string;
  per_page: number;
  prev_page_url: string | null;
  total: number;
}
@Injectable({
  providedIn: 'root'
})
export class CallHistoryService {

  constructor(
    private http: ApiHttpClient,
  ) { }

  get(lenderUserId: number, filter: string, sort: string, page: number): Observable<PaginatedCallHistory> {
    const params: any = {};
    if (filter && filter !== 'all') {
      params.filter = filter;
    }
    if (sort) {
      params.sort = sort;
    }
    if (page) {
      params.page = page;
    }
    return this.http.get<PaginatedCallHistory>(`${environment.API_URL}/user-call-history/${lenderUserId}`,
      { params });
  }

  markCallRead(callId: number) {
    return this.http.post(`${environment.API_URL}/mark-call-read/${callId}`, {});
  }

  markAllMissedCallsRead(lenderUserId: number) {
    return this.http.post(`${environment.API_URL}/mark-all-calls-read/${lenderUserId}`, {});
  }
}
